/**
 * Under-stage ballast stills (narrow / phone chrome gap).
 *
 * Local sources: `assets/ballast/` (`*.orig.*` kept out of the sync).
 * Re-sync public encodes with:
 *   aws --profile voxmedia s3 sync \
 *     apps/duet-csk-theverge/src/stories/data-centers-hub/assets/ballast/ \
 *     s3://assets.sbnation.com/csk/uploads/verge-features/data-centers/data-centers-hub/ballast/ \
 *     --acl public-read --exclude "*" --include "*.webp" --exclude "*.orig.*"
 */

import { hubS3Asset } from "@story/data-centers-hub/config/hubS3";
import type { DeckSlideId } from "@story/data-centers-hub/config/slides";

/** Bust browser/S3 caches after replacing files at the same keys. */
const V = "20261026a";

export function hubBallastAsset(path: string): string {
  return hubS3Asset("ballast", path, V);
}

/** Fixed still per chapter — note shares title. */
export const ballastSlideSrc: Partial<Record<DeckSlideId, string>> = {
  note: hubBallastAsset("title.webp"),
  title: hubBallastAsset("title.webp"),
  virginia: hubBallastAsset("loudoun.webp"),
  utah: hubBallastAsset("utah.webp"),
  arizona: hubBallastAsset("arizona.webp"),
};
